'use client';

import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

type IState = {
  //领域专区
  field: {
    hiddenFooter: boolean;
  };
  eventTracking: {
    mobilePage: {
      [key: string]: {
        'dt-pgid': string;
      };
    };
    pcPage: {
      [key: string]: {
        'dt-pgid': string;
      };
    };
  };
  mediaQuery: 'idle' | 'mobile' | 'pc';
  fieldTitle: string,
};

const initialState: IState = {
  field: {
    hiddenFooter: false,
  },
  mediaQuery: 'idle',
  eventTracking: {
    mobilePage: {
      '/case': {
        'dt-pgid': 'goodcases_indexmobile',
      },
      '/': {
        'dt-pgid': 'page_homemobile',
      },
    },
    pcPage: {
      '/': {
        'dt-pgid': 'page_home',
      },
      '/case': {
        'dt-pgid': 'goodcases_index',
      },
      '/case/search': {
        'dt-pgid': 'search_goodcase',
      },
      '/case/:id': {
        'dt-pgid': 'content_goodcase',
      },
      's-2024': {
        'dt-pgid': 'page_2024_ssv_summit',
      },
    },
  },
   fieldTitle: ''
};

// 跨页面使用兄弟间通讯，不做存储，存储使用useLocalGlobalStore
export const useSiblingStore = create(subscribeWithSelector<IState>(() => ({ ...initialState})));
